import { put, select, takeLatest } from 'redux-saga/effects'
import { getSignersSelector } from '../selectors'
import { setSignerList } from '../store/completeChart.actions'
import { CompleteChartConstants } from '../store/completeChart.constants'
import { ISignerState } from '../store/completeChart.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setAnswer1() {
  const signerState: ISignerState = yield select(getSignersSelector)
  const { answer1, signer, signerList } = signerState
  const selectedAnswer1 = signerList.filter((u) => u.key === signer?.key)
  if (selectedAnswer1 && selectedAnswer1.length) {
    selectedAnswer1[0].answer1 = answer1
    yield put(setSignerList(signerList))
  }
}
export function* setAnswer1Saga() {
  yield takeLatest([CompleteChartConstants.SET_ANSWER1], performWithMutexHOG, setAnswer1)
}
